"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 512 512",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 105.239,
  y: 42.097,
  style: {
    fill: "#A9825A"
  },
  width: 45.514,
  height: 102.838
}), /*#__PURE__*/React.createElement("rect", {
  x: 361.253,
  y: 42.097,
  style: {
    fill: "#A9825A"
  },
  width: 45.514,
  height: 102.838
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFDC35"
  },
  cx: 127.996,
  cy: 53.219,
  r: 53.219
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#FFDC35"
  },
  cx: 384.01,
  cy: 53.219,
  r: 53.219
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FF9900"
  },
  d: "M473.251,291.27H38.749c-17.631,0-31.923-14.292-31.923-31.923v-93.866 c0-17.631,14.292-31.923,31.923-31.923h434.502c17.631,0,31.923,14.292,31.923,31.923v93.866 C505.175,276.978,490.882,291.27,473.251,291.27z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#FFDC35"
  },
  d: "M473.251,133.557H38.749c-17.631,0-31.923,14.294-31.923,31.923v60.369 c0,17.631,14.292,31.923,31.923,31.923h434.502c17.631,0,31.923-14.294,31.923-31.923v-60.369 C505.175,147.85,490.882,133.557,473.251,133.557z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3E3E42"
  },
  d: "M119.853,133.557L6.826,255.008v4.339c0,17.631,14.292,31.923,31.923,31.923h12.045L197.57,133.558 C197.57,133.558,119.853,133.558,119.853,133.557z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#3E3E42"
  },
  points: "284.65,133.557 137.874,291.27 215.591,291.27 362.367,133.557  "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#3E3E42"
  },
  d: "M473.251,133.557h-23.803L302.673,291.27h77.717l123.922-133.156 C500.985,144.037,488.345,133.557,473.251,133.557z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#A9825A"
  },
  d: "M118.439,495.675c0,9.016-7.309,16.325-16.325,16.325H73.101c-9.016,0-16.325-7.31-16.325-16.325 V291.27h61.663V495.675z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#A9825A"
  },
  d: "M455.224,495.675c0,9.016-7.309,16.325-16.325,16.325h-29.014c-9.016,0-16.325-7.31-16.325-16.325 V291.27h61.663L455.224,495.675L455.224,495.675z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 56.776,
  y: 291.276,
  style: {
    fill: "#7E6142"
  },
  width: 61.66,
  height: 25.586
}), /*#__PURE__*/React.createElement("rect", {
  x: 393.556,
  y: 291.276,
  style: {
    fill: "#7E6142"
  },
  width: 61.66,
  height: 25.586
})));
var _default = exports.default = SvgComponent;